module.exports = __webpack_public_path__ + "footerMobile-e7fdee.webp";